'use client';
import React, { useState } from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { getSiteConfig } from '../../../../siteConfig';
import useHideOnSite from '../../../hooks/useLanguageFilter';
import { default as IntegratedFeed } from './feed_listing';

const Feed = ({ blok }) => {
  const [height, setHeight] = useState(1000);

  if (useHideOnSite(blok.hide_on_site) || typeof window === 'undefined') {
    return null;
  } else {
    if (blok.integrated_feed) return <IntegratedFeed blok={blok} />;

    const travelType = blok.travel_type || 'Charter';

    if (travelType === 'Charter' && !blok.packageIds) {
      return <div>Missing packageIds</div>;
    }

    const { ethelBookingURL } = getSiteConfig();

    const packageIds = blok.packageIds
      ? blok.packageIds.split(/\r?\n|\r|\n/g)
      : null;

    const packageIdsString = packageIds
      ? packageIds.filter((p) => p).map((p) => '&packageIds=' + p)
      : '';

    const sortOrder =
      blok.sort_order === 'recommended'
        ? ''
        : `&sort=${blok.sort_order || 'lowestPrice'}`;

    const resizeCrossDomainIframe = () => {
      window.addEventListener(
        'message',
        function (event) {
          if (event.origin !== ethelBookingURL) return; // only accept messages from the specified domain
          if (isNaN(event.data)) return; // only accept something which can be parsed as a number
          var _height = parseInt(event.data) + 32; // add some extra height to avoid scrollbar
          setHeight(_height);
        },
        false,
      );
    };

    var urlParams = new URLSearchParams(window.location.search);

    const airport =
      urlParams?.get('airport') != null
        ? urlParams?.get('airport')
        : blok.airport;

    //const airport = blok.airport;

    const destination =
      urlParams?.get('destination') != null
        ? urlParams?.get('destination').trim()
        : null;

    const periodStart =
      urlParams?.get('date') != null
        ? urlParams?.get('date')
        : blok.selected_period_start.split(' ')[0];

    var adults =
      urlParams.get('persons') != null
        ? Number(urlParams.get('persons'))
        : blok.persons_adults;

    let room = [];
    for (let index = 0; index < adults; index++) {
      room.push(null);
    }
    for (let index = 0; index < blok.persons_children; index++) {
      room.push(8 + index);
    }

    let roomsObject = [room];
    const roomsString = encodeURIComponent(JSON.stringify(roomsObject));

    let periodTo = blok.selected_period_end;
    if (urlParams?.get('date')) {
      var toDate = new Date(periodStart);
      toDate.setDate(toDate.getDate() + 7);
      periodTo = toDate.toISOString().substr(0, 10);
    }

    const src = `${ethelBookingURL}/campaign?${
      travelType !== 'Hotel' ? `airportId=${airport}&` : ''
    }charterTypeId=${
      blok.chartertype
    }&noheader=true&rooms=${roomsString}${sortOrder}${
      periodStart
        ? '&periodFrom=' + periodStart + 'T00%3A00%3A00%2B01%3A00'
        : ''
    }${periodTo ? '&periodTo=' + periodTo + 'T00%3A00%3A00%2B01%3A00' : ''}${
      blok.period_start ? '&travelDateFrom=' + blok.period_start : ''
    }${blok.period_end ? '&travelDateTo=' + blok.period_end : ''}${
      packageIdsString && packageIdsString.join('')
    }${
      destination ? '&destinationId=' + destination : ''
    }&travelType=${travelType}`;

    return (
      <div
        {...storyblokEditable(blok)}
        key={blok._uid}
        id="feed"
        className={`col-span-12 flex flex-col sm:flex-row mt-12 scroll-mt-20`}
      >
        <iframe
          title="feed"
          className={`w-full`}
          style={{
            height: `${height}px`,
            overflow: 'hidden',
            scrollbarWidth: 'none',
          }}
          src={src}
          onLoad={resizeCrossDomainIframe}
          id={blok._uid}
        ></iframe>
      </div>
    );
  }
};

export default Feed;
